// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M21 2H3V6H2V8H22V6H21V2Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M21 10H3V20H2V22H10.5V20H9.5V15.5C9.5 14.1193 10.6193 13 12 13C13.3807 13 14.5 14.1193 14.5 15.5V20H13.5V22H22V20H21V10Z"}}]};

const Dam6FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'dam-6-filled',
    ref,
    icon: element,
  },
));

Dam6FilledIcon.displayName = 'Dam6FilledIcon';

export default Dam6FilledIcon;
